// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3uMKK","header":"ReportDetails_header__2xj_O","title":"ReportDetails_title__1qskb","left":"ReportDetails_left__3qvir"};